import {SGeneralForms, SLocalSelected, SLocalTreeSelected} from "shj-components";
import {useEffect, useRef, useState} from "react";
import {Cascader, TreeSelect, message, Select} from "antd";
import {debounce, isEmpty, throttle} from "lodash-es";
import dayjs from "dayjs";
import {getTicketsInternalConfig} from "@/services/customerServices.ts";
import {convertListToTree, getParentId} from "@/utils/common.ts";
import {getEnums} from "@/services/homeService.ts";

const AddOrEditConfigure = (props) => {
  const {editRef, current, apiObj, treeList} = props;
  const ref = useRef();
  const [internalTree, setInternalTree] = useState([])
  const [levelList, setLevelList] = useState([])

  const onFormRef = () => {
    const {onFormRef} = ref.current || {};
    return onFormRef?.()
  }

  useEffect(() => {
    if (current.key === 'External') getInternalList()
    if (current.key === 'Channel') getLevelList()
  }, []);

  useEffect(() => {
    if (!isEmpty(props.record)) {
      const pathId = getParentId(treeList, props.record.parentId);
      let interPathId ;
      if(current.key === 'External' && !isEmpty(internalTree)) {
        interPathId = getParentId(internalTree, props.record.internalId);
      }
      const obj = {
        ...props.record,
        parentId: pathId?.reverse(),
        internalId: interPathId?.reverse(),
        levelId: String(props.record.levelId),
        startDate: dayjs(props.record.startDate),
        endDate: props.record.endDate && dayjs(props.record.endDate),
      }
      onFormRef()?.setFieldsValue(obj)
    }
    return () => {
      onFormRef()?.resetFields()
    }
  }, [props.record, internalTree]);

  const getInternalList = () => {
    getTicketsInternalConfig({data: {}}).then((res: any[]) => {
      const tree = convertListToTree(res, {pid: 'parentId'})
      setInternalTree(tree)
    })
  }

  const getLevelList = () => {
    getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.OrderIssueLevelEnum').then(res => {
      setLevelList(res)
    })
  }

  const onFinish = () => {
    onFormRef()?.validateFields().then(values => {
      props.setLoading(true)
      const values_ = {
        ...values,
        parentId: values.parentId?.[values.parentId?.length - 1],
        internalId: values.internalId?.[values.internalId?.length - 1],
      }
      const apiUrl = values.id ? apiObj.updateById : apiObj.add
      apiUrl(values_).then(res => {
        message.success(res.message || '操作成功');
        props.fn?.();
        props.onClose?.()
      }).finally(() => props.setLoading(false))
    })
  }

  if (editRef.current) editRef.current.onFinish = onFinish

  return <>
    <SGeneralForms
        ref={ref}
        layout={'vertical'}
        initialValues={{status: false}}
        configs={[{
          formItem: [
            {name: 'id', hidden: true},
            {
              spanCol: 24, label: '父级', name: 'parentId',
              required: true,
              rules: [{required: true, message: '父级不能为空'}],
              children: <Cascader options={treeList}
                                  showSearch
                                  changeOnSelect
                                  expandTrigger={'hover'}
                                  displayRender={(labels: string[]) => labels[labels.length - 1]}
                                  fieldNames={{label: 'name', value: 'id'}}
                                  placeholder={'请选择父级'}/>
            },
            {
              spanCol: 24, label: current.description + '名称', name: `name`,
              required: true,
              rules: [{required: true, message: current.description + '不能为空'}],
              comConfig: {
                maxLength: 20,
                showCount: true,
              }
            },
            {
              spanCol: 24, label: current.description + '描述', name: 'description',
              isDeps: true,
              deps: () => current.key !== 'Channel',
              comConfig: {
                maxLength: 200,
                showCount: true,
              }
            },
            {
              spanCol: 24, label: '关联级别', name: 'levelId',
              required: true,
              rules: [{required: true, message: '关联级别不能为空'}],
              isDeps: true,
              deps: () => current.key === 'Channel',
              children: <Select
                  placeholder={'请选择关联级别'}
                  options={levelList}
                  fieldNames={{label: 'description', value: 'key'}}
              />
            },
            {
              spanCol: 24, label: '关联对内分类', name: `internalId`,
              required: true,
              isDeps: true,
              deps: () => current.key === 'External',
              rules: [{required: true, message: '关联对内分类不能为空'}],
              children: <Cascader options={internalTree}
                                  showSearch
                                  changeOnSelect
                                  expandTrigger={'hover'}
                                  displayRender={(labels: string[]) => labels[labels.length - 1]}
                                  fieldNames={{label: 'name', value: 'id'}}
                                  placeholder={'请选择关联对内分类'}/>
            },
            {
              spanCol: 24,
              label: '是否启用',
              name: 'status',
              type: 'switch'
            },
          ]
        }]}/>
  </>
}

export default AddOrEditConfigure